import { fetchJSON } from '@eventbrite/http';
import isEmpty from 'lodash/isEmpty';
import { ALL_TAB } from '../../../../constants/tabConfig';
import { BucketShape } from '../../../../types/index';
import { buildBBox } from '../../utils';
import {
    setFeCallAsFailed,
    setFeCallAsOngoing,
    setFeCallAsSuccess,
} from '../app/actions';
import { fetchEventsForTab } from '../events/actions';
import { getInitialState } from '../index';
import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';

function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const getRestOfContext = (originalContext: object) => (
    dispatch: Function,
) => {
    dispatch(setFeCallAsOngoing());

    fetchJSON('/fe/')
        .then(async (response: any) => {
            let feResponse = response;

            if (response.flatBucket.__should_suggest_reloading_page) {
                // The homepage backend has a performance optimization where it will always attempt to retrieve
                // events from memcache. If the cache is cold, then it will return __should_suggest_reloading_page to
                // the frontend. If that happens, we want to wait 1000ms and retry one time, hoping that it's
                // enough time to populate the backend cache.
                await sleep(1000);
                feResponse = await fetchJSON('/fe/');
            }

            const filteredResponse = feResponse;

            if (!isEmpty(filteredResponse.buckets)) {
                //we filter out the bucket "liked_events" from the response so we only use the liked_events from the api call
                filteredResponse.buckets = response.buckets.filter(
                    (bucket: BucketShape) => bucket.key !== 'liked_events',
                );
            }

            const fullContext = getInitialState({
                ...originalContext,
                ...filteredResponse,
            });

            if (fullContext.content.browseState.tabKey !== ALL_TAB) {
                fullContext.content.flatBucket = {};
            }

            dispatch({
                type: UPDATE_ROOT_CONTEXT,
                payload: fullContext,
            });

            const {
                content: {
                    flatBucket,
                    browseState: { tabKey },
                },
                location: { placeId, latitude, longitude },
            } = fullContext;

            // TODO: fix the server to perform a search when the cookie contains a lat/lng.
            // Currently, the server only looks for a place id when deciding whether to supply
            // events in the context for the client.  We work around the problem by issuing
            // an ajax search request.  Once the server is fixed, remove the code below.
            if (isEmpty(flatBucket) && !placeId && latitude && longitude) {
                dispatch(
                    fetchEventsForTab({
                        tabKey,
                        locationData: {
                            bbox: buildBBox({ latitude, longitude }),
                        },
                    }),
                );
            }

            dispatch(setFeCallAsSuccess());
        })
        .catch(() => {
            dispatch(setFeCallAsFailed());
        });
};
